export enum UserRole {
Employee = 'employee',
Broker = 'distributor',
Sponsor = 'sponsor'
}